/// <reference types="vite-plugin-svgr/client" />

import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../../assets/location_home.svg';

export const LocationHomeIcon = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
